import * as projectEnvironment from "@restaurant-store-env";

interface Environment {
  readonly FILTER_BY_DATE: boolean;
  readonly FILTER_BY_SESSION: boolean;
  readonly PAGE_SIZE: number;
  readonly REGION_IDS: readonly number[];
  readonly RESTAURANT_PERFORMANCE_MONITORING_ENABLED: boolean;
  readonly SHOW_25_DISCOUNT: string;
}

export const {
  FILTER_BY_DATE,
  FILTER_BY_SESSION,
  PAGE_SIZE,
  REGION_IDS,
  RESTAURANT_PERFORMANCE_MONITORING_ENABLED,
  SHOW_25_DISCOUNT,
} = projectEnvironment satisfies Environment;
